import { GuildIconMono } from '@/atoms/Icons/GuildIconMono'
import { PlaySquareIcon } from '@/atoms/Icons/PlaySquareIcon'
import { CaptionXS } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  pifLabel: string
  guildLabel: string
  guildMembershipIncluded: boolean
}

export const GuildUpsellProgressBarHorizontal = ({ guildMembershipIncluded, pifLabel, guildLabel }: Props) => {
  const { t } = useTranslate('pif')
  return (
    <div className="flex w-full flex-col items-center justify-center gap-1">
      <div className="flex w-full items-center">
        <CaptionXS weight="bold" className="w-1/2 shrink-0 text-balance pr-3 text-center">
          {pifLabel.toUpperCase()}
        </CaptionXS>
        <CaptionXS weight="bold" className="w-1/2 shrink-0 text-balance pr-3 text-center">
          {guildLabel.toUpperCase()}
        </CaptionXS>
      </div>
      <div
        className={`relative h-2.5 w-full rounded-full ${
          guildMembershipIncluded ? 'bg-oxide-primary' : 'bg-core-gray-300'
        }`}
      >
        <div className="h-full w-1/2 rounded-full bg-oxide-primary"></div>
        <div className="absolute left-1/2 top-1/2 flex h-7 w-7 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-oxide-primary">
          <PlaySquareIcon size={16} color="white" />
        </div>
        <div
          className={`absolute right-0 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full ${
            guildMembershipIncluded ? 'bg-oxide-primary' : 'border-2 border-core-gray-200 bg-core-gray-100'
          }`}
        >
          <GuildIconMono size={16} color={guildMembershipIncluded ? 'white' : 'core-gray-400'} className="mt-[2px]" />
        </div>
      </div>
      <div className="flex w-full items-center justify-around">
        <CaptionXS className="w-1/2 shrink-0 text-balance pr-3 text-center">
          {t('payItForward', 'Pay it Forward').toUpperCase()}
        </CaptionXS>
        <CaptionXS className="w-1/2 shrink-0 text-balance pr-3 text-center">
          {t('joinTheGuild', 'Join the Guild').toUpperCase()}
        </CaptionXS>
      </div>
    </div>
  )
}
